import BaseModel from './Base.model';
import UserModel from './User.model';
import { PreorderProgramModel } from './PreorderProgram.model';
import { ProductModel } from './Product.model';

export class PreOrderModel extends BaseModel {
  constructor(data = {}) {
    super({
      id: data.id ?? null,
      createdAt: data.createdAt ?? null,
      updatedAt: data.updatedAt ?? null,
    });

    this.storeId = data.storeId ?? '';
    this.staffId = data.staffId ?? '';
    this.preorderProgramId = data.preorderProgramId ?? null;
    this.type = data.preorderProgram?.type ?? data.type ?? null;
    this.status = data.status ?? null;
    this.customerId = data.customerId ?? data.customer?.id ?? null;
    this.customer = data.customer ?? null;
    this.customerPhone = data.customer?.phoneNumber ?? data.customerPhone ?? '';
    this.customerName = data.customer?.fullName ?? data.customerName ?? '';
    this.customerEmail = data.customer?.email ?? data.customerEmail ?? '';
    this.customerAppellation = data.customer?.gender ?? data.customerAppellation ?? null;
    this.customerAddress = data.customer?.address ?? data.customerAddress ?? '';
    this.customerWardId = data.customerWardId ?? data.customer?.customerAddress?.wardId ?? null;
    this.customerDetailAddress = data.customerDetailAddress ?? data.customer?.customerAddress?.detailAddress ?? '';
    this.customerDateOfBirth = data.customer?.dateOfBirth
      ? (typeof data.customer.dateOfBirth === 'string'
          ? data.customer.dateOfBirth.slice(0, 10)
          : new Date(data.customer.dateOfBirth).toISOString().slice(0, 10))
      : (data.customerDateOfBirth ?? null);
    this.tradeinProductName = data.tradeinProductName ?? '';
    this.tradeinChassisNumber = data.tradeinChassisNumber ?? '';
    this.tradeinEngineNumber = data.tradeinEngineNumber ?? '';
    this.tradeinAttributes = data.tradeinAttributes ?? null;
    this.tradeinEstimationPrice = data.tradeinEstimationPrice ?? null;
    this.tradeinFinalPrice = data.tradeinFinalPrice ?? null;
    this.targetProductId = data.targetProductId ?? null;
    this.targetProductName = data.targetProductName ?? '';
    this.targetQuotedPrice = data.targetQuotedPrice ?? null;
    this.depositAmount = data.depositAmount ?? 0;
    this.cashAccountId = data.cashAccountId ?? null;
    this.cashAccountName = data.cashAccountName ?? '';
    this.note = data.note ?? '';
    this.convertedOrderId = data.convertedOrderId ?? null;

    this.store = data.store ?? null;
    this.staff = UserModel.fromJson(data.staff || {});
    this.preorderProgram = data.preorderProgram
      ? PreorderProgramModel.fromJson(data.preorderProgram)
      : null;
    this.targetProduct = data.targetProduct
      ? ProductModel.fromJson(data.targetProduct)
      : null;
    this.convertedOrder = data.convertedOrder ?? null;
  }

  static fromJson(data) {
    return BaseModel.fromJson(data, PreOrderModel);
  }

  static fromJsonArray(dataArray) {
    return BaseModel.fromJsonArray(dataArray, PreOrderModel);
  }
}
